import { ELEMENT_BOARD, ELEMENT_TABLE_PLUS } from '@sketchnote/slate-plugins';
import { ELEMENT_DATE_TODAY } from '@sketchnote/slate-plugins';
import { TablePlusColorsKeys } from '@sketchnote/table';
import {
  Data,
  ELEMENT_OL,
  ELEMENT_UL,
  insertNodes,
  NoData,
  PlateEditor,
  setNodes,
  TComboboxItem,
  toggleList,
  toggleNodeType,
  useComboboxSelectors,
  useEditorState,
  Value,
} from '@udecode/plate';
import { findMentionInput, findNode, getPluginOptions } from '@udecode/plate';
import { Combobox, ComboboxProps } from '@udecode/plate';
import { format } from 'date-fns';
import React from 'react';
import { Editor, Node, Path, Transforms } from 'slate';
import { v4 as uuidv4 } from 'uuid';

export const ELEMENT_CHANGE_BLOCK = 'change-block';

export const BlockCombobox = <TData extends { type: string }>({
  items,
  component,
  onRenderItem,
  pluginKey = ELEMENT_CHANGE_BLOCK,
  id = pluginKey,
}: Pick<Partial<ComboboxProps<TData>>, 'id' | 'items' | 'component' | 'onRenderItem'> & {
  pluginKey?: string;
}) => {
  const editor: any = useEditorState();
  const targetRange = useComboboxSelectors.targetRange();

  const { trigger } = getPluginOptions<BlockPlugin>(editor, pluginKey);

  return (
    <Combobox
      id={id}
      trigger={trigger!}
      controlled
      items={items}
      component={component}
      onRenderItem={onRenderItem}
      //TODO: editor: any type fix required
      onSelectItem={(editor: any, item) => {
        const itemType = item.data.type;
        const currentMentionInput = findMentionInput(editor);
        if (currentMentionInput) {
          Transforms.removeNodes(editor, { at: currentMentionInput[1] });
          let path = [editor.children.length - 1];
          // removeMentionInput(editor, currentMentionInput[1]);
          const { selection } = editor;
          if (selection?.anchor?.path) {
            path = [selection.anchor.path[0]];
          }
          const node = findNode(editor, { at: path })?.[0];
          const content = node ? Node.string(node) : '';
          if (itemType === ELEMENT_TABLE_PLUS) {
            if (content.length > 0) {
              insertNodes(
                editor,
                {
                  type: ELEMENT_TABLE_PLUS,
                  children: [{ text: '' }],
                  column: tablePlusData.columns,
                  row: tablePlusData.rows,
                },
                { at: Path.next(path) }
              );
            } else {
              setNodes(
                editor,
                {
                  type: ELEMENT_TABLE_PLUS,
                  children: [{ text: '' }],
                  column: tablePlusData.columns,
                  row: tablePlusData.rows,
                },
                { at: path }
              );
            }
          } else if (itemType === ELEMENT_BOARD) {
            if (content.length > 0) {
              insertNodes(
                editor,
                {
                  type: ELEMENT_BOARD,
                  children: [{ text: '' }],
                  columns: boardData.columns,
                },
                { at: Path.next(path) }
              );
            } else {
              setNodes(
                editor,
                {
                  type: ELEMENT_BOARD,
                  children: [{ text: '' }],
                  columns: boardData.columns,
                },
                { at: path }
              );
            }
          } else if (itemType === ELEMENT_UL || itemType === ELEMENT_OL) {
            toggleList(editor, { type: itemType });
          } else if (itemType === ELEMENT_DATE_TODAY) {
            const now = new Date();
            const text = format(now, 'do MMMM, yyyy');
            Transforms.insertText(editor, text);
          } else {
            toggleNodeType(editor, { activeType: itemType || 'p' });
          }
        }
      }}
    />
  );
};

export interface BlockPlugin<TData extends Data = NoData> {
  createMentionNode?: CreateBlockNode<TData>;
  id?: string;
  insertSpaceAfterMention?: boolean;
  trigger?: string;
}

export interface CreateBlockNode<TData extends Data> {
  (item: TComboboxItem<TData>): { value: string };
}

export const tablePlusData = {
  get columns() {
    return [
      {
        key: uuidv4(),
        type: 'text',
        name: 'Name',
        color: getRandomArrayElement(TablePlusColorsKeys),
        width: 300,
      },
      {
        key: uuidv4(),
        type: 'text',
        name: 'Tags',
        color: getRandomArrayElement(TablePlusColorsKeys),
        width: 300,
      },
      {
        key: uuidv4(),
        type: 'text',
        name: 'Versions',
        width: 300,
        color: getRandomArrayElement(TablePlusColorsKeys),
      },
    ];
  },

  get rows() {
    return [{ id: uuidv4() }, { id: uuidv4() }, { id: uuidv4() }];
  },
};

export const getRandomArrayElement = (array: any[]) =>
  array[Math.floor(Math.random() * array.length)];

export const boardData = {
  get columns() {
    return [
      {
        name: 'Requested',
        color: '#F6F7F9',
        id: uuidv4(),
        items: [
          { id: uuidv4(), topic: 'First task' },
          { id: uuidv4(), topic: 'Second task' },
        ],
      },
      {
        name: 'To do',
        color: '#FEEFED',
        id: uuidv4(),
        items: [],
      },
      {
        name: 'In Progress',
        color: '#FFF7D6',
        id: uuidv4(),
        items: [],
      },
      {
        name: 'Done',
        color: '#DFF8E3',
        id: uuidv4(),
        items: [],
      },
      {
        name: 'Testing',
        color: '#DFF8E3',
        id: uuidv4(),
        items: [],
      },
    ];
  },
};
